export default {
  "imports": {
    "@jsenv/node-module-import-map/": "/node_modules/@jsenv/node-module-import-map/",
    "@jsenv/node-module-import-map": "/node_modules/@jsenv/node-module-import-map/index.js",
    "@jsenv/prettier-check-project": "/node_modules/@jsenv/prettier-check-project/index.js",
    "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
    "@dmail/process-signals": "/node_modules/@dmail/process-signals/index.js",
    "@jsenv/prettier-config": "/node_modules/@jsenv/prettier-config/index.js",
    "@jsenv/codecov-upload": "/node_modules/@jsenv/codecov-upload/index.js",
    "@jsenv/eslint-config": "/node_modules/@jsenv/eslint-config/index.js",
    "@jsenv/node-launcher": "/node_modules/@jsenv/node-launcher/index.js",
    "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
    "@jsenv/bundling/": "/node_modules/@jsenv/bundling/",
    "@jsenv/execution": "/node_modules/@jsenv/execution/index.js",
    "@jsenv/bundling": "/node_modules/@jsenv/bundling/index.js",
    "@jsenv/testing/": "/node_modules/@jsenv/testing/",
    "@jsenv/testing": "/node_modules/@jsenv/testing/index.js",
    "@dmail/assert": "/node_modules/@dmail/assert/index.js",
    "@dmail/helper": "/node_modules/@dmail/helper/index.js",
    "@jsenv/logger": "/node_modules/@jsenv/logger/index.js",
    "@jsenv/href/": "/node_modules/@jsenv/href/",
    "@jsenv/href": "/node_modules/@jsenv/href/index.js",
    "node-fetch": "/node_modules/node-fetch/lib/index.mjs",
    "node-forge": "/node_modules/node-forge/lib/index.js",
    "kill-port": "/node_modules/kill-port/index.js",
    "prettier": "/node_modules/prettier/index.js",
    "eslint": "/node_modules/eslint/lib/api.js",
    "rimraf": "/node_modules/rimraf/rimraf.js"
  },
  "scopes": {
    "/node_modules/istanbul-lib-instrument/node_modules/@babel/traverse/node_modules/@babel/types/": {
      "to-fast-properties": "/node_modules/to-fast-properties/index.js",
      "esutils": "/node_modules/esutils/lib/utils.js",
      "lodash": "/node_modules/lodash/lodash.js"
    },
    "/node_modules/@dmail/filesystem-watch/node_modules/@jsenv/operating-system-path/": {
      "@jsenv/module-resolution": "/node_modules/@jsenv/module-resolution/index.js"
    },
    "/node_modules/@jsenv/core/node_modules/@babel/plugin-transform-modules-systemjs/": {
      "babel-plugin-dynamic-import-node": "/node_modules/babel-plugin-dynamic-import-node/lib/index.js",
      "@babel/helper-hoist-variables": "/node_modules/@babel/helper-hoist-variables/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@jsenv/core/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@jsenv/core/node_modules/@babel/core/node_modules/@babel/helpers/": {
      "@babel/template": "/node_modules/@jsenv/core/node_modules/@babel/template/lib/index.js",
      "@babel/traverse": "/node_modules/@jsenv/core/node_modules/@babel/traverse/lib/index.js",
      "@babel/types": "/node_modules/@jsenv/core/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@jsenv/eslint-import-resolver/node_modules/@jsenv/import-map/": {
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js"
    },
    "/node_modules/@jsenv/node-module-import-map/node_modules/@jsenv/import-map/": {
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js"
    },
    "/node_modules/@jsenv/node-launcher/node_modules/@jsenv/module-resolution/": {
      "@jsenv/import-map/": "/node_modules/@jsenv/node-launcher/node_modules/@jsenv/import-map/",
      "@jsenv/import-map": "/node_modules/@jsenv/node-launcher/node_modules/@jsenv/import-map/index.js",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js"
    },
    "/node_modules/@babel/helper-builder-binary-assignment-operator-visitor/": {
      "@babel/helper-explode-assignable-expression": "/node_modules/@babel/helper-explode-assignable-expression/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@jsenv/core/node_modules/babel-plugin-transform-commonjs/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@jsenv/core/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@dmail/server/node_modules/@jsenv/operating-system-path/": {
      "@jsenv/module-resolution": "/node_modules/@jsenv/module-resolution/index.js"
    },
    "/node_modules/@dmail/filesystem-watch/node_modules/@jsenv/url-meta/": {
      "@jsenv/module-resolution": "/node_modules/@jsenv/module-resolution/index.js"
    },
    "/node_modules/istanbul-lib-instrument/node_modules/@babel/traverse/": {
      "@babel/helper-split-export-declaration": "/node_modules/@babel/helper-split-export-declaration/lib/index.js",
      "@babel/helper-function-name": "/node_modules/@babel/helper-function-name/lib/index.js",
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/generator": "/node_modules/@babel/generator/lib/index.js",
      "@babel/parser": "/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/istanbul-lib-instrument/node_modules/@babel/traverse/node_modules/@babel/types/lib/index.js",
      "globals": "/node_modules/globals/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "debug": "/node_modules/debug/src/index.js"
    },
    "/node_modules/@jsenv/node-launcher/node_modules/@jsenv/import-map/": {
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js"
    },
    "/node_modules/@babel/plugin-transform-exponentiation-operator/": {
      "@babel/helper-builder-binary-assignment-operator-visitor": "/node_modules/@babel/helper-builder-binary-assignment-operator-visitor/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/istanbul-lib-report/node_modules/supports-color/": {
      "has-flag": "/node_modules/istanbul-lib-report/node_modules/has-flag/index.js"
    },
    "/node_modules/@babel/plugin-transform-block-scoped-functions/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@jsenv/url-meta/node_modules/@jsenv/import-map/": {
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js"
    },
    "/node_modules/eslint-import-resolver-node/node_modules/debug/": {
      "ms": "/node_modules/eslint-import-resolver-node/node_modules/ms/index.js"
    },
    "/node_modules/@babel/plugin-proposal-optional-catch-binding/": {
      "@babel/plugin-syntax-optional-catch-binding": "/node_modules/@babel/plugin-syntax-optional-catch-binding/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-proposal-unicode-property-regex/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/helper-regex": "/node_modules/@babel/helper-regex/lib/index.js",
      "regexpu-core": "/node_modules/regexpu-core/rewrite-pattern.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/traverse/node_modules/@babel/generator/": {
      "@babel/types": "/node_modules/@babel/types/lib/index.js",
      "source-map": "/node_modules/source-map/source-map.js",
      "trim-right": "/node_modules/trim-right/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "jsesc": "/node_modules/jsesc/jsesc.js"
    },
    "/node_modules/@babel/helper-member-expression-to-functions/": {
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-shorthand-properties/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/helper-explode-assignable-expression/": {
      "@babel/traverse": "/node_modules/@babel/traverse/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@babel/plugin-syntax-optional-catch-binding/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-computed-properties/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@jsenv/testing/node_modules/@babel/template/": {
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/parser": "/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@jsenv/testing/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@jsenv/testing/node_modules/@babel/traverse/": {
      "@babel/helper-split-export-declaration": "/node_modules/@babel/helper-split-export-declaration/lib/index.js",
      "@babel/helper-function-name": "/node_modules/@babel/helper-function-name/lib/index.js",
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/generator": "/node_modules/@babel/generator/lib/index.js",
      "@babel/parser": "/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@jsenv/testing/node_modules/@babel/types/lib/index.js",
      "globals": "/node_modules/globals/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "debug": "/node_modules/debug/src/index.js"
    },
    "/node_modules/@babel/generator/node_modules/@babel/types/": {
      "to-fast-properties": "/node_modules/to-fast-properties/index.js",
      "esutils": "/node_modules/esutils/lib/utils.js",
      "lodash": "/node_modules/lodash/lodash.js"
    },
    "/node_modules/@jsenv/testing/node_modules/@babel/helpers/": {
      "@babel/template": "/node_modules/@jsenv/testing/node_modules/@babel/template/lib/index.js",
      "@babel/traverse": "/node_modules/@jsenv/testing/node_modules/@babel/traverse/lib/index.js",
      "@babel/types": "/node_modules/@jsenv/testing/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/eslint-plugin-import/node_modules/doctrine/": {
      "esutils": "/node_modules/esutils/lib/utils.js",
      "isarray": "/node_modules/isarray/index.js"
    },
    "/node_modules/@babel/core/node_modules/@babel/generator/": {
      "@babel/types": "/node_modules/@babel/types/lib/index.js",
      "source-map": "/node_modules/source-map/source-map.js",
      "trim-right": "/node_modules/trim-right/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "jsesc": "/node_modules/jsesc/jsesc.js"
    },
    "/node_modules/@babel/plugin-proposal-object-rest-spread/": {
      "@babel/plugin-syntax-object-rest-spread": "/node_modules/@babel/plugin-syntax-object-rest-spread/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-template-literals/": {
      "@babel/helper-annotate-as-pure": "/node_modules/@babel/helper-annotate-as-pure/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/eslint-plugin-react/node_modules/doctrine/": {
      "esutils": "/node_modules/esutils/lib/utils.js"
    },
    "/node_modules/@jsenv/core/node_modules/@babel/template/": {
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/parser": "/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@jsenv/core/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@jsenv/core/node_modules/@babel/traverse/": {
      "@babel/helper-split-export-declaration": "/node_modules/@babel/helper-split-export-declaration/lib/index.js",
      "@babel/helper-function-name": "/node_modules/@babel/helper-function-name/lib/index.js",
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/generator": "/node_modules/@babel/generator/lib/index.js",
      "@babel/parser": "/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@jsenv/core/node_modules/@babel/types/lib/index.js",
      "globals": "/node_modules/globals/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "debug": "/node_modules/debug/src/index.js"
    },
    "/node_modules/@jsenv/testing/node_modules/@babel/types/": {
      "to-fast-properties": "/node_modules/to-fast-properties/index.js",
      "esutils": "/node_modules/esutils/lib/utils.js",
      "lodash": "/node_modules/lodash/lodash.js"
    },
    "/node_modules/@babel/plugin-syntax-object-rest-spread/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-arrow-functions/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@jsenv/core/node_modules/@babel/helpers/": {
      "@babel/template": "/node_modules/@jsenv/core/node_modules/@babel/template/lib/index.js",
      "@babel/traverse": "/node_modules/@jsenv/core/node_modules/@babel/traverse/lib/index.js",
      "@babel/types": "/node_modules/@jsenv/core/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@jsenv/testing/node_modules/@babel/core/": {
      "convert-source-map": "/node_modules/convert-source-map/index.js",
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/generator": "/node_modules/@babel/generator/lib/index.js",
      "@babel/template": "/node_modules/@jsenv/testing/node_modules/@babel/template/lib/index.js",
      "@babel/traverse": "/node_modules/@jsenv/testing/node_modules/@babel/traverse/lib/index.js",
      "@babel/helpers": "/node_modules/@jsenv/testing/node_modules/@babel/helpers/lib/index.js",
      "@babel/parser": "/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@jsenv/testing/node_modules/@babel/types/lib/index.js",
      "source-map": "/node_modules/source-map/source-map.js",
      "resolve": "/node_modules/resolve/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "semver": "/node_modules/semver/semver.js",
      "debug": "/node_modules/debug/src/index.js",
      "json5": "/node_modules/json5/lib/index.js"
    },
    "/node_modules/eslint-plugin-import/node_modules/debug/": {
      "ms": "/node_modules/eslint-plugin-import/node_modules/ms/index.js"
    },
    "/node_modules/@babel/helper-optimise-call-expression/": {
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@babel/helper-split-export-declaration/": {
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-duplicate-keys/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/babel-eslint/node_modules/eslint-scope/": {
      "estraverse": "/node_modules/estraverse/estraverse.js",
      "esrecurse": "/node_modules/esrecurse/esrecurse.js"
    },
    "/node_modules/eslint-module-utils/node_modules/debug/": {
      "ms": "/node_modules/eslint-module-utils/node_modules/ms/index.js"
    },
    "/node_modules/@babel/plugin-transform-block-scoping/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js",
      "lodash": "/node_modules/lodash/lodash.js"
    },
    "/node_modules/@babel/plugin-transform-destructuring/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-function-name/": {
      "@babel/helper-function-name": "/node_modules/@babel/helper-function-name/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-typeof-symbol/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-unicode-regex/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/helper-regex": "/node_modules/@babel/helper-regex/lib/index.js",
      "regexpu-core": "/node_modules/regexpu-core/rewrite-pattern.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@jsenv/core/node_modules/@babel/types/": {
      "to-fast-properties": "/node_modules/to-fast-properties/index.js",
      "esutils": "/node_modules/esutils/lib/utils.js",
      "lodash": "/node_modules/lodash/lodash.js"
    },
    "/node_modules/@babel/plugin-transform-dotall-regex/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/helper-regex": "/node_modules/@babel/helper-regex/lib/index.js",
      "regexpu-core": "/node_modules/regexpu-core/rewrite-pattern.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-object-super/": {
      "@babel/helper-replace-supers": "/node_modules/@babel/helper-replace-supers/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-sticky-regex/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/helper-regex": "/node_modules/@babel/helper-regex/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@dmail/server/node_modules/kill-port/": {
      "get-them-args": "/node_modules/get-them-args/index.js",
      "shell-exec": "/node_modules/shell-exec/index.js"
    },
    "/node_modules/@jsenv/core/node_modules/@babel/core/": {
      "convert-source-map": "/node_modules/convert-source-map/index.js",
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/generator": "/node_modules/@babel/generator/lib/index.js",
      "@babel/template": "/node_modules/@jsenv/core/node_modules/@babel/template/lib/index.js",
      "@babel/traverse": "/node_modules/@jsenv/core/node_modules/@babel/traverse/lib/index.js",
      "@babel/helpers": "/node_modules/@jsenv/core/node_modules/@babel/core/node_modules/@babel/helpers/lib/index.js",
      "@babel/parser": "/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@jsenv/core/node_modules/@babel/types/lib/index.js",
      "source-map": "/node_modules/source-map/source-map.js",
      "resolve": "/node_modules/resolve/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "semver": "/node_modules/semver/semver.js",
      "debug": "/node_modules/debug/src/index.js",
      "json5": "/node_modules/json5/lib/index.js"
    },
    "/node_modules/https-proxy-agent/node_modules/debug/": {
      "ms": "/node_modules/ms/index.js"
    },
    "/node_modules/string-width/node_modules/strip-ansi/": {
      "ansi-regex": "/node_modules/string-width/node_modules/ansi-regex/index.js"
    },
    "/node_modules/@babel/plugin-proposal-json-strings/": {
      "@babel/plugin-syntax-json-strings": "/node_modules/@babel/plugin-syntax-json-strings/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-syntax-dynamic-import/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-regenerator/": {
      "regenerator-transform": "/node_modules/regenerator-transform/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-new-target/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-parameters/": {
      "@babel/helper-get-function-arity": "/node_modules/@babel/helper-get-function-arity/lib/index.js",
      "@babel/helper-call-delegate": "/node_modules/@babel/helper-call-delegate/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-syntax-json-strings/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/unicode-match-property-ecmascript/": {
      "unicode-canonical-property-names-ecmascript": "/node_modules/unicode-canonical-property-names-ecmascript/index.js",
      "unicode-property-aliases-ecmascript": "/node_modules/unicode-property-aliases-ecmascript/index.js"
    },
    "/node_modules/@babel/helper-get-function-arity/": {
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@babel/plugin-syntax-import-meta/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-literals/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/babel-plugin-dynamic-import-node/": {
      "object.assign": "/node_modules/object.assign/index.js"
    },
    "/node_modules/@babel/plugin-transform-classes/": {
      "@babel/helper-optimise-call-expression": "/node_modules/@babel/helper-optimise-call-expression/lib/index.js",
      "@babel/helper-split-export-declaration": "/node_modules/@babel/helper-split-export-declaration/lib/index.js",
      "@babel/helper-annotate-as-pure": "/node_modules/@babel/helper-annotate-as-pure/lib/index.js",
      "@babel/helper-replace-supers": "/node_modules/@babel/helper-replace-supers/lib/index.js",
      "@babel/helper-function-name": "/node_modules/@babel/helper-function-name/lib/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/helper-define-map": "/node_modules/@babel/helper-define-map/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js",
      "globals": "/node_modules/globals/index.js"
    },
    "/node_modules/table/node_modules/string-width/": {
      "is-fullwidth-code-point": "/node_modules/is-fullwidth-code-point/index.js",
      "emoji-regex": "/node_modules/emoji-regex/index.js",
      "strip-ansi": "/node_modules/strip-ansi/index.js"
    },
    "/node_modules/@babel/helper-annotate-as-pure/": {
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-for-of/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@babel/plugin-transform-spread/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/flat-cache/node_modules/rimraf/": {
      "glob": "/node_modules/glob/glob.js"
    },
    "/node_modules/@babel/helper-hoist-variables/": {
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@jsenv/eslint-import-resolver/": {
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@jsenv/import-map/": "/node_modules/@jsenv/eslint-import-resolver/node_modules/@jsenv/import-map/",
      "@jsenv/import-map": "/node_modules/@jsenv/eslint-import-resolver/node_modules/@jsenv/import-map/index.js",
      "@jsenv/logger": "/node_modules/@jsenv/logger/index.js",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js"
    },
    "/node_modules/@jsenv/node-module-import-map/": {
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "@jsenv/import-map/": "/node_modules/@jsenv/node-module-import-map/node_modules/@jsenv/import-map/",
      "@jsenv/import-map": "/node_modules/@jsenv/node-module-import-map/node_modules/@jsenv/import-map/index.js",
      "@dmail/helper": "/node_modules/@dmail/helper/index.js"
    },
    "/node_modules/@jsenv/prettier-check-project/": {
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@dmail/filesystem-matching": "/node_modules/@dmail/filesystem-matching/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "@jsenv/url-meta": "/node_modules/@jsenv/url-meta/index.js",
      "prettier": "/node_modules/prettier/index.js"
    },
    "/node_modules/regenerate-unicode-properties/": {
      "regenerate": "/node_modules/regenerate/regenerate.js"
    },
    "/node_modules/@babel/helper-module-imports/": {
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@babel/helper-replace-supers/": {
      "@babel/helper-member-expression-to-functions": "/node_modules/@babel/helper-member-expression-to-functions/lib/index.js",
      "@babel/helper-optimise-call-expression": "/node_modules/@babel/helper-optimise-call-expression/lib/index.js",
      "@babel/traverse": "/node_modules/@babel/traverse/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@jsenv/error-stack-sourcemap/": {
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js",
      "source-map": "/node_modules/@jsenv/error-stack-sourcemap/node_modules/source-map/source-map.js"
    },
    "/node_modules/@jsenv/operating-system-path/": {
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js"
    },
    "/node_modules/validate-npm-package-license/": {
      "spdx-expression-parse": "/node_modules/spdx-expression-parse/index.js",
      "spdx-correct": "/node_modules/spdx-correct/index.js"
    },
    "/node_modules/@babel/helper-call-delegate/": {
      "@babel/helper-hoist-variables": "/node_modules/@babel/helper-hoist-variables/lib/index.js",
      "@babel/traverse": "/node_modules/@babel/traverse/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@babel/helper-function-name/": {
      "@babel/helper-get-function-arity": "/node_modules/@babel/helper-get-function-arity/lib/index.js",
      "@babel/template": "/node_modules/@babel/template/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/eslint-import-resolver-node/": {
      "resolve": "/node_modules/resolve/index.js",
      "debug": "/node_modules/eslint-import-resolver-node/node_modules/debug/src/index.js"
    },
    "/node_modules/@dmail/filesystem-matching/": {
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "@jsenv/url-meta": "/node_modules/@jsenv/url-meta/index.js"
    },
    "/node_modules/@babel/helper-define-map/": {
      "@babel/helper-function-name": "/node_modules/@babel/helper-function-name/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js",
      "lodash": "/node_modules/lodash/lodash.js"
    },
    "/node_modules/@babel/plugin-syntax-jsx/": {
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@dmail/filesystem-watch/": {
      "@jsenv/operating-system-path": "/node_modules/@dmail/filesystem-watch/node_modules/@jsenv/operating-system-path/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "@jsenv/url-meta": "/node_modules/@dmail/filesystem-watch/node_modules/@jsenv/url-meta/index.js"
    },
    "/node_modules/@jsenv/babel-plugin-map/": {
      "@babel/plugin-transform-exponentiation-operator": "/node_modules/@babel/plugin-transform-exponentiation-operator/lib/index.js",
      "@babel/plugin-transform-block-scoped-functions": "/node_modules/@babel/plugin-transform-block-scoped-functions/lib/index.js",
      "@babel/plugin-proposal-optional-catch-binding": "/node_modules/@babel/plugin-proposal-optional-catch-binding/lib/index.js",
      "@babel/plugin-proposal-unicode-property-regex": "/node_modules/@babel/plugin-proposal-unicode-property-regex/lib/index.js",
      "@babel/plugin-transform-shorthand-properties": "/node_modules/@babel/plugin-transform-shorthand-properties/lib/index.js",
      "@babel/plugin-syntax-optional-catch-binding": "/node_modules/@babel/plugin-syntax-optional-catch-binding/lib/index.js",
      "@babel/plugin-transform-computed-properties": "/node_modules/@babel/plugin-transform-computed-properties/lib/index.js",
      "@babel/plugin-proposal-object-rest-spread": "/node_modules/@babel/plugin-proposal-object-rest-spread/lib/index.js",
      "@babel/plugin-transform-template-literals": "/node_modules/@babel/plugin-transform-template-literals/lib/index.js",
      "babel-plugin-transform-async-to-promises": "/node_modules/babel-plugin-transform-async-to-promises/async-to-promises.js",
      "@babel/plugin-syntax-object-rest-spread": "/node_modules/@babel/plugin-syntax-object-rest-spread/lib/index.js",
      "@babel/plugin-transform-arrow-functions": "/node_modules/@babel/plugin-transform-arrow-functions/lib/index.js",
      "@babel/plugin-transform-duplicate-keys": "/node_modules/@babel/plugin-transform-duplicate-keys/lib/index.js",
      "@babel/plugin-transform-block-scoping": "/node_modules/@babel/plugin-transform-block-scoping/lib/index.js",
      "@babel/plugin-transform-destructuring": "/node_modules/@babel/plugin-transform-destructuring/lib/index.js",
      "@babel/plugin-transform-function-name": "/node_modules/@babel/plugin-transform-function-name/lib/index.js",
      "@babel/plugin-transform-typeof-symbol": "/node_modules/@babel/plugin-transform-typeof-symbol/lib/index.js",
      "@babel/plugin-transform-unicode-regex": "/node_modules/@babel/plugin-transform-unicode-regex/lib/index.js",
      "@babel/plugin-transform-dotall-regex": "/node_modules/@babel/plugin-transform-dotall-regex/lib/index.js",
      "@babel/plugin-transform-object-super": "/node_modules/@babel/plugin-transform-object-super/lib/index.js",
      "@babel/plugin-transform-sticky-regex": "/node_modules/@babel/plugin-transform-sticky-regex/lib/index.js",
      "@babel/plugin-proposal-json-strings": "/node_modules/@babel/plugin-proposal-json-strings/lib/index.js",
      "@babel/plugin-transform-regenerator": "/node_modules/@babel/plugin-transform-regenerator/lib/index.js",
      "@babel/plugin-transform-new-target": "/node_modules/@babel/plugin-transform-new-target/lib/index.js",
      "@babel/plugin-transform-parameters": "/node_modules/@babel/plugin-transform-parameters/lib/index.js",
      "@babel/plugin-transform-literals": "/node_modules/@babel/plugin-transform-literals/lib/index.js",
      "@babel/plugin-transform-classes": "/node_modules/@babel/plugin-transform-classes/lib/index.js",
      "@babel/plugin-transform-for-of": "/node_modules/@babel/plugin-transform-for-of/lib/index.js",
      "@babel/plugin-transform-spread": "/node_modules/@babel/plugin-transform-spread/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/istanbul-lib-instrument/": {
      "istanbul-lib-coverage": "/node_modules/istanbul-lib-coverage/index.js",
      "@babel/generator": "/node_modules/@babel/generator/lib/index.js",
      "@babel/template": "/node_modules/@babel/template/lib/index.js",
      "@babel/traverse": "/node_modules/istanbul-lib-instrument/node_modules/@babel/traverse/lib/index.js",
      "@babel/parser": "/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js",
      "semver": "/node_modules/istanbul-lib-instrument/node_modules/semver/semver.js"
    },
    "/node_modules/@dmail/process-signals/": {
      "@dmail/helper": "/node_modules/@dmail/helper/index.js"
    },
    "/node_modules/normalize-package-data/": {
      "validate-npm-package-license": "/node_modules/validate-npm-package-license/index.js",
      "hosted-git-info": "/node_modules/hosted-git-info/index.js",
      "resolve": "/node_modules/resolve/index.js",
      "semver": "/node_modules/semver/semver.js"
    },
    "/node_modules/@jsenv/codecov-upload/": {
      "codecov": "/node_modules/codecov/index.js"
    },
    "/node_modules/@jsenv/compile-server/": {
      "@jsenv/node-module-import-map/": "/node_modules/@jsenv/node-module-import-map/",
      "@jsenv/node-module-import-map": "/node_modules/@jsenv/node-module-import-map/index.js",
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@dmail/filesystem-watch": "/node_modules/@dmail/filesystem-watch/index.js",
      "@jsenv/babel-plugin-map": "/node_modules/@jsenv/babel-plugin-map/index.js",
      "@dmail/process-signals": "/node_modules/@dmail/process-signals/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "@jsenv/import-map/": "/node_modules/@jsenv/import-map/",
      "@jsenv/import-map": "/node_modules/@jsenv/import-map/index.js",
      "@jsenv/bundling/": "/node_modules/@jsenv/bundling/",
      "abort-controller": "/node_modules/abort-controller/dist/abort-controller.js",
      "@jsenv/bundling": "/node_modules/@jsenv/bundling/index.js",
      "@jsenv/url-meta": "/node_modules/@jsenv/url-meta/index.js",
      "@dmail/helper": "/node_modules/@dmail/helper/index.js",
      "@dmail/server": "/node_modules/@dmail/server/index.js",
      "@dmail/uneval": "/node_modules/@dmail/uneval/index.js",
      "@jsenv/logger": "/node_modules/@jsenv/logger/index.js",
      "@jsenv/core/": "/node_modules/@jsenv/core/",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/core": "/node_modules/@jsenv/core/index.js",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js",
      "eventsource": "/node_modules/eventsource/lib/eventsource.js",
      "node-fetch": "/node_modules/node-fetch/lib/index.mjs",
      "systemjs": "/node_modules/systemjs/index.js"
    },
    "/node_modules/regenerator-transform/": {
      "private": "/node_modules/private/private.js"
    },
    "/node_modules/spdx-expression-parse/": {
      "spdx-license-ids": "/node_modules/spdx-license-ids/index.json",
      "spdx-exceptions": "/node_modules/spdx-exceptions/index.json"
    },
    "/node_modules/@jsenv/eslint-config/": {
      "@babel/plugin-syntax-dynamic-import": "/node_modules/@babel/plugin-syntax-dynamic-import/lib/index.js",
      "@babel/plugin-syntax-import-meta": "/node_modules/@babel/plugin-syntax-import-meta/lib/index.js",
      "@jsenv/eslint-import-resolver": "/node_modules/@jsenv/eslint-import-resolver/index.js",
      "@babel/plugin-syntax-jsx": "/node_modules/@babel/plugin-syntax-jsx/lib/index.js",
      "eslint-plugin-import": "/node_modules/eslint-plugin-import/lib/index.js",
      "eslint-plugin-react": "/node_modules/eslint-plugin-react/index.js",
      "babel-eslint": "/node_modules/babel-eslint/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js"
    },
    "/node_modules/@jsenv/node-launcher/": {
      "@jsenv/module-resolution/isNativeNodeModuleBareSpecifier.js": "/node_modules/@jsenv/node-launcher/node_modules/@jsenv/module-resolution/src/isNativeNodeModuleBareSpecifier.js",
      "@jsenv/node-module-import-map/": "/node_modules/@jsenv/node-module-import-map/",
      "@jsenv/error-stack-sourcemap/": "/node_modules/@jsenv/error-stack-sourcemap/",
      "@jsenv/node-module-import-map": "/node_modules/@jsenv/node-module-import-map/index.js",
      "@jsenv/error-stack-sourcemap": "/node_modules/@jsenv/error-stack-sourcemap/index.js",
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@jsenv/module-resolution/": "/node_modules/@jsenv/node-launcher/node_modules/@jsenv/module-resolution/",
      "@jsenv/module-resolution": "/node_modules/@jsenv/node-launcher/node_modules/@jsenv/module-resolution/index.js",
      "@jsenv/babel-plugin-map": "/node_modules/@jsenv/babel-plugin-map/index.js",
      "@dmail/process-signals": "/node_modules/@dmail/process-signals/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "@jsenv/bundling/": "/node_modules/@jsenv/bundling/",
      "abort-controller": "/node_modules/abort-controller/dist/abort-controller.js",
      "@jsenv/bundling": "/node_modules/@jsenv/bundling/index.js",
      "@dmail/server": "/node_modules/@dmail/server/index.js",
      "@dmail/uneval": "/node_modules/@dmail/uneval/index.js",
      "@jsenv/logger": "/node_modules/@jsenv/logger/index.js",
      "@jsenv/core/": "/node_modules/@jsenv/core/",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/core": "/node_modules/@jsenv/core/index.js",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js",
      "node-fetch": "/node_modules/node-fetch/lib/index.mjs",
      "source-map": "/node_modules/@jsenv/node-launcher/node_modules/source-map/source-map.js"
    },
    "/node_modules/eslint-plugin-import/": {
      "eslint-import-resolver-node": "/node_modules/eslint-import-resolver-node/index.js",
      "eslint-module-utils": "/node_modules/eslint-module-utils/index.js",
      "array-includes": "/node_modules/array-includes/index.js",
      "contains-path": "/node_modules/contains-path/index.js",
      "object.values": "/node_modules/object.values/index.js",
      "read-pkg-up": "/node_modules/read-pkg-up/index.js",
      "minimatch": "/node_modules/minimatch/minimatch.js",
      "doctrine": "/node_modules/eslint-plugin-import/node_modules/doctrine/lib/doctrine.js",
      "resolve": "/node_modules/resolve/index.js",
      "eslint": "/node_modules/eslint/lib/api.js",
      "debug": "/node_modules/eslint-plugin-import/node_modules/debug/src/index.js",
      "has": "/node_modules/has/src.js"
    },
    "/node_modules/@babel/helper-regex/": {
      "lodash": "/node_modules/lodash/lodash.js"
    },
    "/node_modules/eslint-module-utils/": {
      "pkg-dir": "/node_modules/pkg-dir/index.js",
      "debug": "/node_modules/eslint-module-utils/node_modules/debug/src/index.js"
    },
    "/node_modules/eslint-plugin-react/": {
      "object.fromentries": "/node_modules/object.fromentries/index.js",
      "array-includes": "/node_modules/array-includes/index.js",
      "object.entries": "/node_modules/object.entries/index.js",
      "jsx-ast-utils": "/node_modules/jsx-ast-utils/lib/index.js",
      "object.values": "/node_modules/object.values/index.js",
      "prop-types": "/node_modules/prop-types/index.js",
      "doctrine": "/node_modules/eslint-plugin-react/node_modules/doctrine/lib/doctrine.js",
      "resolve": "/node_modules/resolve/index.js",
      "eslint": "/node_modules/eslint/lib/api.js",
      "has": "/node_modules/has/src.js"
    },
    "/node_modules/istanbul-lib-report/": {
      "istanbul-lib-coverage": "/node_modules/istanbul-lib-coverage/index.js",
      "supports-color": "/node_modules/istanbul-lib-report/node_modules/supports-color/index.js",
      "make-dir": "/node_modules/make-dir/index.js"
    },
    "/node_modules/convert-source-map/": {
      "safe-buffer": "/node_modules/safe-buffer/index.js"
    },
    "/node_modules/object.fromentries/": {
      "define-properties": "/node_modules/define-properties/index.js",
      "function-bind": "/node_modules/function-bind/index.js",
      "es-abstract": "/node_modules/es-abstract/index.js",
      "has": "/node_modules/has/src.js"
    },
    "/node_modules/source-map-support/": {
      "buffer-from": "/node_modules/buffer-from/index.js",
      "source-map": "/node_modules/source-map-support/node_modules/source-map/source-map.js"
    },
    "/node_modules/@babel/code-frame/": {
      "@babel/highlight": "/node_modules/@babel/highlight/lib/index.js"
    },
    "/node_modules/@jsenv/import-map/": {
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js"
    },
    "/node_modules/define-properties/": {
      "object-keys": "/node_modules/object-keys/index.js"
    },
    "/node_modules/https-proxy-agent/": {
      "agent-base": "/node_modules/agent-base/index.js",
      "debug": "/node_modules/https-proxy-agent/node_modules/debug/src/index.js"
    },
    "/node_modules/@babel/generator/": {
      "@babel/types": "/node_modules/@babel/generator/node_modules/@babel/types/lib/index.js",
      "source-map": "/node_modules/source-map/source-map.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "jsesc": "/node_modules/jsesc/jsesc.js"
    },
    "/node_modules/@babel/highlight/": {
      "js-tokens": "/node_modules/js-tokens/index.js",
      "esutils": "/node_modules/esutils/lib/utils.js",
      "chalk": "/node_modules/chalk/index.js"
    },
    "/node_modules/@jsenv/execution/": {
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@jsenv/compile-server/": "/node_modules/@jsenv/compile-server/",
      "@jsenv/compile-server": "/node_modules/@jsenv/compile-server/index.js",
      "istanbul-lib-coverage": "/node_modules/@jsenv/execution/node_modules/istanbul-lib-coverage/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "@dmail/helper": "/node_modules/@dmail/helper/index.js",
      "@jsenv/logger": "/node_modules/@jsenv/logger/index.js",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js",
      "eventsource": "/node_modules/eventsource/lib/eventsource.js"
    },
    "/node_modules/abort-controller/": {
      "event-target-shim": "/node_modules/event-target-shim/dist/event-target-shim.js"
    },
    "/node_modules/file-entry-cache/": {
      "flat-cache": "/node_modules/flat-cache/cache.js"
    },
    "/node_modules/istanbul-reports/": {
      "handlebars": "/node_modules/handlebars/lib/index.js"
    },
    "/node_modules/@babel/template/": {
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/parser": "/node_modules/@babel/template/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@babel/traverse/": {
      "@babel/helper-split-export-declaration": "/node_modules/@babel/helper-split-export-declaration/lib/index.js",
      "@babel/helper-function-name": "/node_modules/@babel/helper-function-name/lib/index.js",
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/generator": "/node_modules/@babel/traverse/node_modules/@babel/generator/lib/index.js",
      "@babel/parser": "/node_modules/@babel/traverse/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js",
      "globals": "/node_modules/globals/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "debug": "/node_modules/debug/src/index.js"
    },
    "/node_modules/@jsenv/bundling/": {
      "@jsenv/node-module-import-map/": "/node_modules/@jsenv/node-module-import-map/",
      "@jsenv/node-module-import-map": "/node_modules/@jsenv/node-module-import-map/index.js",
      "@babel/helper-module-imports": "/node_modules/@babel/helper-module-imports/lib/index.js",
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@jsenv/babel-plugin-map": "/node_modules/@jsenv/babel-plugin-map/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "@jsenv/import-map/": "/node_modules/@jsenv/import-map/",
      "@jsenv/import-map": "/node_modules/@jsenv/import-map/index.js",
      "abort-controller": "/node_modules/abort-controller/dist/abort-controller.js",
      "@dmail/helper": "/node_modules/@dmail/helper/index.js",
      "@jsenv/logger": "/node_modules/@jsenv/logger/index.js",
      "@jsenv/core/": "/node_modules/@jsenv/core/",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/core": "/node_modules/@jsenv/core/index.js",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js",
      "node-fetch": "/node_modules/node-fetch/lib/index.mjs",
      "rollup": "/node_modules/rollup/dist/rollup.es.js",
      "terser": "/node_modules/terser/dist/bundle.min.js"
    },
    "/node_modules/@jsenv/url-meta/": {
      "@jsenv/import-map/": "/node_modules/@jsenv/url-meta/node_modules/@jsenv/import-map/",
      "@jsenv/import-map": "/node_modules/@jsenv/url-meta/node_modules/@jsenv/import-map/index.js"
    },
    "/node_modules/brace-expansion/": {
      "balanced-match": "/node_modules/balanced-match/index.js",
      "concat-map": "/node_modules/concat-map/index.js"
    },
    "/node_modules/es-to-primitive/": {
      "is-date-object": "/node_modules/is-date-object/index.js",
      "is-callable": "/node_modules/is-callable/index.js",
      "is-symbol": "/node_modules/is-symbol/index.js"
    },
    "/node_modules/external-editor/": {
      "iconv-lite": "/node_modules/iconv-lite/lib/index.js",
      "chardet": "/node_modules/chardet/index.js",
      "tmp": "/node_modules/tmp/lib/tmp.js"
    },
    "/node_modules/proper-lockfile/": {
      "graceful-fs": "/node_modules/graceful-fs/graceful-fs.js",
      "signal-exit": "/node_modules/signal-exit/index.js",
      "retry": "/node_modules/retry/index.js"
    },
    "/node_modules/shebang-command/": {
      "shebang-regex": "/node_modules/shebang-regex/index.js"
    },
    "/node_modules/@babel/helpers/": {
      "@babel/template": "/node_modules/@babel/template/lib/index.js",
      "@babel/traverse": "/node_modules/@babel/traverse/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js"
    },
    "/node_modules/@jsenv/testing/": {
      "@babel/plugin-syntax-dynamic-import": "/node_modules/@babel/plugin-syntax-dynamic-import/lib/index.js",
      "@babel/plugin-syntax-import-meta": "/node_modules/@babel/plugin-syntax-import-meta/lib/index.js",
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@dmail/filesystem-matching": "/node_modules/@dmail/filesystem-matching/index.js",
      "@dmail/filesystem-watch": "/node_modules/@dmail/filesystem-watch/index.js",
      "istanbul-lib-instrument": "/node_modules/istanbul-lib-instrument/dist/index.js",
      "@jsenv/compile-server/": "/node_modules/@jsenv/compile-server/",
      "@jsenv/compile-server": "/node_modules/@jsenv/compile-server/index.js",
      "istanbul-lib-coverage": "/node_modules/istanbul-lib-coverage/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "istanbul-lib-report": "/node_modules/istanbul-lib-report/index.js",
      "@jsenv/execution": "/node_modules/@jsenv/execution/index.js",
      "istanbul-reports": "/node_modules/istanbul-reports/index.js",
      "@jsenv/url-meta": "/node_modules/@jsenv/url-meta/index.js",
      "@dmail/helper": "/node_modules/@dmail/helper/index.js",
      "@jsenv/logger": "/node_modules/@jsenv/logger/index.js",
      "node-notifier": "/node_modules/node-notifier/index.js",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@babel/core": "/node_modules/@jsenv/testing/node_modules/@babel/core/lib/index.js",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js",
      "node-fetch": "/node_modules/node-fetch/lib/index.mjs",
      "cuid": "/node_modules/cuid/index.js"
    },
    "/node_modules/array-includes/": {
      "define-properties": "/node_modules/define-properties/index.js",
      "es-abstract": "/node_modules/es-abstract/index.js"
    },
    "/node_modules/load-json-file/": {
      "graceful-fs": "/node_modules/graceful-fs/graceful-fs.js",
      "parse-json": "/node_modules/parse-json/index.js",
      "strip-bom": "/node_modules/strip-bom/index.js",
      "pify": "/node_modules/pify/index.js"
    },
    "/node_modules/object.entries/": {
      "define-properties": "/node_modules/define-properties/index.js",
      "function-bind": "/node_modules/function-bind/index.js",
      "es-abstract": "/node_modules/es-abstract/index.js",
      "has": "/node_modules/has/src.js"
    },
    "/node_modules/restore-cursor/": {
      "signal-exit": "/node_modules/signal-exit/index.js",
      "onetime": "/node_modules/onetime/index.js"
    },
    "/node_modules/supports-color/": {
      "has-flag": "/node_modules/has-flag/index.js"
    },
    "/node_modules/@dmail/assert/": {
      "@dmail/inspect": "/node_modules/@dmail/inspect/index.js"
    },
    "/node_modules/@dmail/server/": {
      "@jsenv/operating-system-path": "/node_modules/@dmail/server/node_modules/@jsenv/operating-system-path/index.js",
      "@dmail/process-signals": "/node_modules/@dmail/process-signals/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "@dmail/helper": "/node_modules/@dmail/helper/index.js",
      "@jsenv/logger": "/node_modules/@jsenv/logger/index.js",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js",
      "kill-port": "/node_modules/@dmail/server/node_modules/kill-port/index.js"
    },
    "/node_modules/color-convert/": {
      "color-name": "/node_modules/color-name/index.js"
    },
    "/node_modules/es6-promisify/": {
      "es6-promise": "/node_modules/es6-promise/dist/es6-promise.js"
    },
    "/node_modules/jsx-ast-utils/": {
      "array-includes": "/node_modules/array-includes/index.js",
      "object.assign": "/node_modules/object.assign/index.js"
    },
    "/node_modules/node-notifier/": {
      "shellwords": "/node_modules/shellwords/lib/shellwords.js",
      "growly": "/node_modules/growly/lib/growly.js",
      "is-wsl": "/node_modules/is-wsl/index.js",
      "semver": "/node_modules/semver/semver.js",
      "which": "/node_modules/which/which.js"
    },
    "/node_modules/object.assign/": {
      "define-properties": "/node_modules/define-properties/index.js",
      "function-bind": "/node_modules/function-bind/index.js",
      "has-symbols": "/node_modules/has-symbols/index.js",
      "object-keys": "/node_modules/object-keys/index.js"
    },
    "/node_modules/object.values/": {
      "define-properties": "/node_modules/define-properties/index.js",
      "function-bind": "/node_modules/function-bind/index.js",
      "es-abstract": "/node_modules/es-abstract/index.js",
      "has": "/node_modules/has/src.js"
    },
    "/node_modules/parent-module/": {
      "callsites": "/node_modules/callsites/index.js"
    },
    "/node_modules/teeny-request/": {
      "https-proxy-agent": "/node_modules/https-proxy-agent/index.js",
      "node-fetch": "/node_modules/node-fetch/lib/index.mjs",
      "uuid": "/node_modules/uuid/index.js"
    },
    "/node_modules/@babel/types/": {
      "to-fast-properties": "/node_modules/to-fast-properties/index.js",
      "esutils": "/node_modules/esutils/lib/utils.js",
      "lodash": "/node_modules/lodash/lodash.js"
    },
    "/node_modules/ansi-to-html/": {
      "entities": "/node_modules/entities/index.js"
    },
    "/node_modules/babel-eslint/": {
      "eslint-visitor-keys": "/node_modules/eslint-visitor-keys/lib/index.js",
      "eslint-scope": "/node_modules/babel-eslint/node_modules/eslint-scope/lib/index.js",
      "@babel/core": "/node_modules/@babel/core/lib/index.js",
      "eslint": "/node_modules/eslint/lib/api.js",
      "semver": "/node_modules/semver/semver.js"
    },
    "/node_modules/eslint-scope/": {
      "estraverse": "/node_modules/estraverse/estraverse.js",
      "esrecurse": "/node_modules/esrecurse/esrecurse.js"
    },
    "/node_modules/eslint-utils/": {
      "eslint-visitor-keys": "/node_modules/eslint-visitor-keys/lib/index.js"
    },
    "/node_modules/import-fresh/": {
      "parent-module": "/node_modules/parent-module/index.js",
      "resolve-from": "/node_modules/resolve-from/index.js"
    },
    "/node_modules/loose-envify/": {
      "js-tokens": "/node_modules/js-tokens/index.js"
    },
    "/node_modules/regexpu-core/": {
      "unicode-match-property-value-ecmascript": "/node_modules/unicode-match-property-value-ecmascript/index.js",
      "unicode-match-property-ecmascript": "/node_modules/unicode-match-property-ecmascript/index.js",
      "regenerate-unicode-properties": "/node_modules/regenerate-unicode-properties/index.js",
      "regjsparser": "/node_modules/regjsparser/parser.js",
      "regenerate": "/node_modules/regenerate/regenerate.js",
      "regjsgen": "/node_modules/regjsgen/regjsgen.js"
    },
    "/node_modules/spdx-correct/": {
      "spdx-expression-parse": "/node_modules/spdx-expression-parse/index.js",
      "spdx-license-ids": "/node_modules/spdx-license-ids/index.json"
    },
    "/node_modules/string-width/": {
      "is-fullwidth-code-point": "/node_modules/is-fullwidth-code-point/index.js",
      "strip-ansi": "/node_modules/string-width/node_modules/strip-ansi/index.js"
    },
    "/node_modules/@babel/core/": {
      "convert-source-map": "/node_modules/convert-source-map/index.js",
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "@babel/generator": "/node_modules/@babel/core/node_modules/@babel/generator/lib/index.js",
      "@babel/template": "/node_modules/@babel/template/lib/index.js",
      "@babel/traverse": "/node_modules/@babel/traverse/lib/index.js",
      "@babel/helpers": "/node_modules/@babel/helpers/lib/index.js",
      "@babel/parser": "/node_modules/@babel/core/node_modules/@babel/parser/lib/index.js",
      "@babel/types": "/node_modules/@babel/types/lib/index.js",
      "source-map": "/node_modules/source-map/source-map.js",
      "resolve": "/node_modules/resolve/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "semver": "/node_modules/semver/semver.js",
      "debug": "/node_modules/debug/src/index.js",
      "json5": "/node_modules/json5/lib/index.js"
    },
    "/node_modules/@jsenv/core/": {
      "@babel/plugin-transform-modules-systemjs": "/node_modules/@jsenv/core/node_modules/@babel/plugin-transform-modules-systemjs/lib/index.js",
      "@babel/plugin-syntax-dynamic-import": "/node_modules/@babel/plugin-syntax-dynamic-import/lib/index.js",
      "@babel/plugin-syntax-import-meta": "/node_modules/@babel/plugin-syntax-import-meta/lib/index.js",
      "babel-plugin-transform-commonjs": "/node_modules/@jsenv/core/node_modules/babel-plugin-transform-commonjs/dist/index.js",
      "@babel/helper-hoist-variables": "/node_modules/@babel/helper-hoist-variables/lib/index.js",
      "@jsenv/operating-system-path": "/node_modules/@jsenv/operating-system-path/index.js",
      "@babel/helper-plugin-utils": "/node_modules/@babel/helper-plugin-utils/lib/index.js",
      "@jsenv/babel-plugin-map": "/node_modules/@jsenv/babel-plugin-map/index.js",
      "@dmail/cancellation": "/node_modules/@dmail/cancellation/index.js",
      "regenerator-runtime": "/node_modules/regenerator-runtime/runtime.js",
      "@jsenv/import-map/": "/node_modules/@jsenv/import-map/",
      "@jsenv/import-map": "/node_modules/@jsenv/import-map/index.js",
      "@jsenv/url-meta": "/node_modules/@jsenv/url-meta/index.js",
      "proper-lockfile": "/node_modules/proper-lockfile/index.js",
      "@babel/helpers": "/node_modules/@jsenv/core/node_modules/@babel/helpers/lib/index.js",
      "@dmail/helper": "/node_modules/@dmail/helper/index.js",
      "@dmail/server": "/node_modules/@dmail/server/index.js",
      "@jsenv/logger": "/node_modules/@jsenv/logger/index.js",
      "@jsenv/href/": "/node_modules/@jsenv/href/",
      "ansi-to-html": "/node_modules/ansi-to-html/lib/ansi_to_html.js",
      "@babel/core": "/node_modules/@jsenv/core/node_modules/@babel/core/lib/index.js",
      "@jsenv/href": "/node_modules/@jsenv/href/index.js",
      "rimraf": "/node_modules/rimraf/rimraf.js"
    },
    "/node_modules/ansi-styles/": {
      "color-convert": "/node_modules/color-convert/index.js"
    },
    "/node_modules/cross-spawn/": {
      "shebang-command": "/node_modules/shebang-command/index.js",
      "nice-try": "/node_modules/nice-try/src/index.js",
      "path-key": "/node_modules/path-key/index.js",
      "semver": "/node_modules/semver/semver.js",
      "which": "/node_modules/which/which.js"
    },
    "/node_modules/es-abstract/": {
      "es-to-primitive": "/node_modules/es-to-primitive/index.js",
      "function-bind": "/node_modules/function-bind/index.js",
      "is-callable": "/node_modules/is-callable/index.js",
      "object-keys": "/node_modules/object-keys/index.js",
      "is-regex": "/node_modules/is-regex/index.js",
      "has": "/node_modules/has/src.js"
    },
    "/node_modules/eventsource/": {
      "original": "/node_modules/original/index.js"
    },
    "/node_modules/glob-parent/": {
      "is-glob": "/node_modules/is-glob/index.js"
    },
    "/node_modules/ignore-walk/": {
      "minimatch": "/node_modules/minimatch/minimatch.js"
    },
    "/node_modules/locate-path/": {
      "path-exists": "/node_modules/path-exists/index.js",
      "p-locate": "/node_modules/p-locate/index.js"
    },
    "/node_modules/read-pkg-up/": {
      "read-pkg": "/node_modules/read-pkg/index.js",
      "find-up": "/node_modules/find-up/index.js"
    },
    "/node_modules/regjsparser/": {
      "jsesc": "/node_modules/regjsparser/node_modules/jsesc/jsesc.js"
    },
    "/node_modules/agent-base/": {
      "es6-promisify": "/node_modules/es6-promisify/dist/promisify.js"
    },
    "/node_modules/cli-cursor/": {
      "restore-cursor": "/node_modules/restore-cursor/index.js"
    },
    "/node_modules/flat-cache/": {
      "flatted": "/node_modules/flatted/esm/index.js",
      "rimraf": "/node_modules/flat-cache/node_modules/rimraf/rimraf.js",
      "write": "/node_modules/write/index.js"
    },
    "/node_modules/handlebars/": {
      "source-map": "/node_modules/handlebars/node_modules/source-map/source-map.js",
      "neo-async": "/node_modules/neo-async/async.js",
      "optimist": "/node_modules/optimist/index.js"
    },
    "/node_modules/iconv-lite/": {
      "safer-buffer": "/node_modules/safer-buffer/safer.js"
    },
    "/node_modules/optionator/": {
      "fast-levenshtein": "/node_modules/fast-levenshtein/levenshtein.js",
      "prelude-ls": "/node_modules/prelude-ls/lib/.js",
      "type-check": "/node_modules/type-check/lib/.js",
      "wordwrap": "/node_modules/wordwrap/index.js",
      "deep-is": "/node_modules/deep-is/index.js",
      "levn": "/node_modules/levn/lib/.js"
    },
    "/node_modules/parse-json/": {
      "error-ex": "/node_modules/error-ex/index.js"
    },
    "/node_modules/prop-types/": {
      "object-assign": "/node_modules/object-assign/index.js",
      "loose-envify": "/node_modules/loose-envify/index.js",
      "react-is": "/node_modules/react-is/index.js"
    },
    "/node_modules/slice-ansi/": {
      "is-fullwidth-code-point": "/node_modules/is-fullwidth-code-point/index.js",
      "astral-regex": "/node_modules/astral-regex/index.js",
      "ansi-styles": "/node_modules/ansi-styles/index.js"
    },
    "/node_modules/strip-ansi/": {
      "ansi-regex": "/node_modules/ansi-regex/index.js"
    },
    "/node_modules/type-check/": {
      "prelude-ls": "/node_modules/prelude-ls/lib/.js"
    },
    "/node_modules/acorn-jsx/": {
      "acorn": "/node_modules/acorn/dist/acorn.mjs"
    },
    "/node_modules/esrecurse/": {
      "estraverse": "/node_modules/estraverse/estraverse.js"
    },
    "/node_modules/is-symbol/": {
      "has-symbols": "/node_modules/has-symbols/index.js"
    },
    "/node_modules/kill-port/": {
      "get-them-args": "/node_modules/get-them-args/index.js",
      "shell-exec": "/node_modules/shell-exec/index.js"
    },
    "/node_modules/minimatch/": {
      "brace-expansion": "/node_modules/brace-expansion/index.js"
    },
    "/node_modules/path-type/": {
      "pify": "/node_modules/pify/index.js"
    },
    "/node_modules/run-async/": {
      "is-promise": "/node_modules/is-promise/index.js"
    },
    "/node_modules/url-parse/": {
      "querystringify": "/node_modules/querystringify/index.js",
      "requires-port": "/node_modules/requires-port/index.js"
    },
    "/node_modules/argparse/": {
      "sprintf-js": "/node_modules/sprintf-js/src/sprintf.js"
    },
    "/node_modules/doctrine/": {
      "esutils": "/node_modules/esutils/lib/utils.js"
    },
    "/node_modules/error-ex/": {
      "is-arrayish": "/node_modules/is-arrayish/index.js"
    },
    "/node_modules/inflight/": {
      "wrappy": "/node_modules/wrappy/wrappy.js",
      "once": "/node_modules/once/once.js"
    },
    "/node_modules/inquirer/": {
      "external-editor": "/node_modules/external-editor/main/index.js",
      "ansi-escapes": "/node_modules/ansi-escapes/index.js",
      "string-width": "/node_modules/string-width/index.js",
      "mute-stream": "/node_modules/mute-stream/mute.js",
      "cli-cursor": "/node_modules/cli-cursor/index.js",
      "strip-ansi": "/node_modules/strip-ansi/index.js",
      "cli-width": "/node_modules/cli-width/index.js",
      "run-async": "/node_modules/run-async/index.js",
      "figures": "/node_modules/figures/index.js",
      "through": "/node_modules/through/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "chalk": "/node_modules/chalk/index.js",
      "rxjs": "/node_modules/rxjs/_esm5/index.js"
    },
    "/node_modules/is-regex/": {
      "has": "/node_modules/has/src.js"
    },
    "/node_modules/make-dir/": {
      "semver": "/node_modules/make-dir/node_modules/semver/semver.js"
    },
    "/node_modules/optimist/": {
      "minimist": "/node_modules/minimist/index.js",
      "wordwrap": "/node_modules/optimist/node_modules/wordwrap/index.js"
    },
    "/node_modules/original/": {
      "url-parse": "/node_modules/url-parse/index.js"
    },
    "/node_modules/p-locate/": {
      "p-limit": "/node_modules/p-limit/index.js"
    },
    "/node_modules/read-pkg/": {
      "normalize-package-data": "/node_modules/normalize-package-data/lib/normalize.js",
      "load-json-file": "/node_modules/load-json-file/index.js",
      "path-type": "/node_modules/path-type/index.js"
    },
    "/node_modules/codecov/": {
      "teeny-request": "/node_modules/teeny-request/build/src/index.js",
      "ignore-walk": "/node_modules/ignore-walk/index.js",
      "js-yaml": "/node_modules/js-yaml/index.js",
      "urlgrey": "/node_modules/urlgrey/index.js",
      "argv": "/node_modules/argv/index.js"
    },
    "/node_modules/esquery/": {
      "estraverse": "/node_modules/estraverse/estraverse.js"
    },
    "/node_modules/figures/": {
      "escape-string-regexp": "/node_modules/escape-string-regexp/index.js"
    },
    "/node_modules/find-up/": {
      "locate-path": "/node_modules/locate-path/index.js"
    },
    "/node_modules/is-glob/": {
      "is-extglob": "/node_modules/is-extglob/index.js"
    },
    "/node_modules/js-yaml/": {
      "argparse": "/node_modules/argparse/index.js",
      "esprima": "/node_modules/esprima/dist/esprima.js"
    },
    "/node_modules/onetime/": {
      "mimic-fn": "/node_modules/mimic-fn/index.js"
    },
    "/node_modules/p-limit/": {
      "p-try": "/node_modules/p-try/index.js"
    },
    "/node_modules/pkg-dir/": {
      "find-up": "/node_modules/find-up/index.js"
    },
    "/node_modules/resolve/": {
      "path-parse": "/node_modules/path-parse/index.js"
    },
    "/node_modules/eslint/": {
      "json-stable-stringify-without-jsonify": "/node_modules/json-stable-stringify-without-jsonify/index.js",
      "functional-red-black-tree": "/node_modules/functional-red-black-tree/rbtree.js",
      "eslint-visitor-keys": "/node_modules/eslint-visitor-keys/lib/index.js",
      "strip-json-comments": "/node_modules/strip-json-comments/index.js",
      "@babel/code-frame": "/node_modules/@babel/code-frame/lib/index.js",
      "file-entry-cache": "/node_modules/file-entry-cache/cache.js",
      "v8-compile-cache": "/node_modules/v8-compile-cache/v8-compile-cache.js",
      "natural-compare": "/node_modules/natural-compare/index.js",
      "eslint-scope": "/node_modules/eslint-scope/lib/index.js",
      "eslint-utils": "/node_modules/eslint-utils/index.mjs",
      "import-fresh": "/node_modules/import-fresh/index.js",
      "cross-spawn": "/node_modules/cross-spawn/index.js",
      "glob-parent": "/node_modules/glob-parent/index.js",
      "imurmurhash": "/node_modules/imurmurhash/imurmurhash.js",
      "optionator": "/node_modules/optionator/lib/.js",
      "strip-ansi": "/node_modules/strip-ansi/index.js",
      "text-table": "/node_modules/text-table/index.js",
      "minimatch": "/node_modules/minimatch/minimatch.js",
      "doctrine": "/node_modules/doctrine/lib/doctrine.js",
      "inquirer": "/node_modules/inquirer/lib/inquirer.js",
      "progress": "/node_modules/progress/index.js",
      "esquery": "/node_modules/esquery/esquery.js",
      "esutils": "/node_modules/esutils/lib/utils.js",
      "globals": "/node_modules/globals/index.js",
      "is-glob": "/node_modules/is-glob/index.js",
      "js-yaml": "/node_modules/js-yaml/index.js",
      "regexpp": "/node_modules/regexpp/index.js",
      "espree": "/node_modules/espree/espree.js",
      "ignore": "/node_modules/ignore/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "mkdirp": "/node_modules/mkdirp/index.js",
      "semver": "/node_modules/eslint/node_modules/semver/semver.js",
      "chalk": "/node_modules/chalk/index.js",
      "debug": "/node_modules/debug/src/index.js",
      "table": "/node_modules/table/dist/index.js",
      "levn": "/node_modules/levn/lib/.js",
      "ajv": "/node_modules/ajv/lib/ajv.js"
    },
    "/node_modules/espree/": {
      "eslint-visitor-keys": "/node_modules/eslint-visitor-keys/lib/index.js",
      "acorn-jsx": "/node_modules/acorn-jsx/index.js",
      "acorn": "/node_modules/acorn/dist/acorn.mjs"
    },
    "/node_modules/mkdirp/": {
      "minimist": "/node_modules/minimist/index.js"
    },
    "/node_modules/rimraf/": {
      "glob": "/node_modules/glob/glob.js"
    },
    "/node_modules/rollup/": {
      "acorn": "/node_modules/acorn/dist/acorn.mjs"
    },
    "/node_modules/terser/": {
      "source-map-support": "/node_modules/source-map-support/source-map-support.js",
      "source-map": "/node_modules/terser/node_modules/source-map/source-map.js",
      "commander": "/node_modules/commander/index.js"
    },
    "/node_modules/uri-js/": {
      "punycode": "/node_modules/punycode/punycode.es6.js"
    },
    "/node_modules/chalk/": {
      "escape-string-regexp": "/node_modules/escape-string-regexp/index.js",
      "supports-color": "/node_modules/supports-color/index.js",
      "ansi-styles": "/node_modules/ansi-styles/index.js"
    },
    "/node_modules/debug/": {
      "ms": "/node_modules/ms/index.js"
    },
    "/node_modules/json5/": {
      "minimist": "/node_modules/json5/node_modules/minimist/index.js"
    },
    "/node_modules/table/": {
      "string-width": "/node_modules/table/node_modules/string-width/index.js",
      "slice-ansi": "/node_modules/slice-ansi/index.js",
      "lodash": "/node_modules/lodash/lodash.js",
      "ajv": "/node_modules/ajv/lib/ajv.js"
    },
    "/node_modules/which/": {
      "isexe": "/node_modules/isexe/index.js"
    },
    "/node_modules/write/": {
      "mkdirp": "/node_modules/mkdirp/index.js"
    },
    "/node_modules/glob/": {
      "path-is-absolute": "/node_modules/path-is-absolute/index.js",
      "fs.realpath": "/node_modules/fs.realpath/index.js",
      "minimatch": "/node_modules/minimatch/minimatch.js",
      "inflight": "/node_modules/inflight/inflight.js",
      "inherits": "/node_modules/inherits/inherits.js",
      "once": "/node_modules/once/once.js"
    },
    "/node_modules/levn/": {
      "prelude-ls": "/node_modules/prelude-ls/lib/.js",
      "type-check": "/node_modules/type-check/lib/.js"
    },
    "/node_modules/once/": {
      "wrappy": "/node_modules/wrappy/wrappy.js"
    },
    "/node_modules/rxjs/": {
      "tslib": "/node_modules/tslib/tslib.es6.js"
    },
    "/node_modules/ajv/": {
      "fast-json-stable-stringify": "/node_modules/fast-json-stable-stringify/index.js",
      "json-schema-traverse": "/node_modules/json-schema-traverse/index.js",
      "fast-deep-equal": "/node_modules/fast-deep-equal/index.js",
      "uri-js": "/node_modules/uri-js/dist/es5/uri.all.js"
    },
    "/node_modules/has/": {
      "function-bind": "/node_modules/function-bind/index.js"
    },
    "/node_modules/tmp/": {
      "os-tmpdir": "/node_modules/os-tmpdir/index.js"
    }
  }
}